<div class="one" fxLayout="column" [formGroup]="MatterPropertyDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNALLOTMENT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNALLOTMENT),
      }"
    >
      <mat-label>Allotment</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNALLOTMENT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNALLOTMENT"
      />
      @if (testBool && toolTipList.CROWNALLOTMENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNALLOTMENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CROWNALLOTMENT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNBLOCK),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNBLOCK),
      }"
    >
      <mat-label>Block</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNBLOCK?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNBLOCK"
      />
      @if (testBool && toolTipList.CROWNBLOCK) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNBLOCK.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CROWNBLOCK?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNSECTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNSECTION),
      }"
    >
      <mat-label>Section</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNSECTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNSECTION"
      />
      @if (testBool && toolTipList.CROWNSECTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNSECTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CROWNSECTION?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNPORTION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNPORTION),
      }"
    >
      <mat-label>Portion</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNPORTION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNPORTION"
      />
      @if (testBool && toolTipList.CROWNPORTION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNPORTION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CROWNPORTION?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNSUBDIVISION),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNSUBDIVISION),
      }"
    >
      <mat-label>Sub Division</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNSUBDIVISION?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNSUBDIVISION"
      />
      @if (testBool && toolTipList.CROWNSUBDIVISION) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNSUBDIVISION.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.CROWNSUBDIVISION?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="75"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CROWNPARISH),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CROWNPARISH),
      }"
    >
      <mat-label>Parish</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CROWNPARISH?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CROWNPARISH"
      />
      @if (testBool && toolTipList.CROWNPARISH) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CROWNPARISH.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CROWNPARISH?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</div>
